import { useMemo, useState } from "react";
import { generateWritingContext } from "../domain/contextGen";
import { getMoment } from "../domain/engine";
import { useStore } from "../store";

export function Writing() {
  const { bible, world, selection } = useStore();
  const [picked, setPicked] = useState<string[]>(["alinoe", "bjorn"]);
  const [arcs, setArcs] = useState<string[]>(["arc:time-loop"]);
  const [authorSecrets, setAuthorSecrets] = useState(true);
  const [issues, setIssues] = useState(true);
  const [copied, setCopied] = useState(false);
  const moment = bible ? getMoment(bible, selection.momentId) : undefined;
  const text = useMemo(() => {
    if (!bible || !selection.momentId) return "";
    return generateWritingContext(bible, selection, {
      momentId: selection.momentId,
      characterIds: picked,
      arcIds: arcs,
      includeAuthorSecrets: authorSecrets,
      includeOpenIssues: issues,
      world,
    });
  }, [arcs, authorSecrets, bible, issues, picked, selection, world]);

  if (!bible) return null;
  const copy = async () => {
    await navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <div className="grid">
      <h1>Contexte d’écriture</h1>
      {!moment && <p className="warn">Sélectionnez un moment dans la lentille (tome, chapitre, et la branche s’il y en a plusieurs).</p>}
      <section className="card">
        <h2>Inclusions</h2>
        <div className="grid grid-2">
          <div>
            <h3>Personnages</h3>
            {bible.characters.map((c) => (
              <label key={c.id} className="row">
                <input
                  type="checkbox"
                  checked={picked.includes(c.id)}
                  onChange={(e) => setPicked((prev) => e.target.checked ? [...prev, c.id] : prev.filter((x) => x !== c.id))}
                />
                {c.name}
              </label>
            ))}
          </div>
          <div>
            <h3>Arcs</h3>
            {world.arcs.map((a) => (
              <label key={a.id} className="row">
                <input
                  type="checkbox"
                  checked={arcs.includes(a.id)}
                  onChange={(e) => setArcs((prev) => e.target.checked ? [...prev, a.id] : prev.filter((x) => x !== a.id))}
                />
                {a.title}
              </label>
            ))}
            <label className="row">
              <input type="checkbox" checked={authorSecrets} onChange={(e) => setAuthorSecrets(e.target.checked)} />
              Secrets d’auteur
            </label>
            <label className="row">
              <input type="checkbox" checked={issues} onChange={(e) => setIssues(e.target.checked)} />
              Contradictions ouvertes
            </label>
          </div>
        </div>
      </section>
      <div className="row">
        <button className="btn primary" type="button" disabled={!text} onClick={() => void copy()}>
          {copied ? "Copié" : "Copier pour Cursor / ChatGPT"}
        </button>
      </div>
      <pre className="context">{text || "Rien à générer tant qu’un moment n’est pas choisi."}</pre>
    </div>
  );
}
